module.exports = __webpack_public_path__ + "static/media/hero-img.4c187d9a.png";